import AiProductPreview from "./AiProductPreview";
import StarvyPreview from "./StarvyPreview";
import ProductImagePreview from "./ProductImagePreview";

export default function ProductVisual({ product }) {
  if (product.id === "ai") return <AiProductPreview product={product} />;
  if (product.id === "starvy") return <StarvyPreview />;
  return <ProductImagePreview product={product} />;
}
